import api, { HttpResponse } from '../utils/api'
import { NotificationModel } from "../common/models/CommonModels";

export const fetchUnreadNotifications = (): Promise<NotificationModel[]> => {
    return api.get("api/notifications/unread").then((response: HttpResponse) => {
        if (response.status === 200) {
            const res: NotificationModel[] = <NotificationModel[]>response.data;
            return res;
        }
        return [];
    })
}

export const fetchNewestNotification = (): Promise<NotificationModel[]> => {
    return api.get("api/notifications/newest/unread").then((response: HttpResponse) => {
        if (response.status === 200) {
            if (response.data){
                // API response contains only one item
                const res: NotificationModel[] = <NotificationModel[]>[response.data];
                return res;
            }
            else {
                // Response does not contain any item
                return [];
            }
        }
        return [];
    })
}

export const addNotification = (notification: NotificationModel): Promise<boolean> => {
    return api.post("api/notifications", notification).then((response: HttpResponse) => {
        return response.status === 200;
    }).catch(e => {
        return false;
    });
}

export const setNotificationRead = (id: string): Promise<boolean> => {
    const url = `api/notifications/setRead/${id}`;

    return api.put(url).then((response: HttpResponse) => {
        return response.status === 200;
    }).catch(e => {
        return false;
    });
}


// WEBPACK FOOTER //
// ./src/api/notificationsApi.ts